import { useEffect } from "react";
import { useCartService } from "../../../hooks/use-cart-service";
import { getQueryStringParam } from "../../query-string";

export const useGrin = () => {
	const { cart, setCartCustomField, cartLoading } = useCartService();

	useEffect(() => {
		const isGrin = getQueryStringParam("platform") === "grin";
		if (isGrin && !cartLoading) {
			const grinLinkId = getQueryStringParam("link_id");
			if (grinLinkId && grinLinkId !== cart?.custom.fields.grinLinkId) {
				void setCartCustomField("grinLinkId", grinLinkId);
			}
		}
	}, [cartLoading, setCartCustomField, cart?.custom.fields.grinLinkId]);
};
